import { useStateContext } from '../modules/stateContext';

const useExperiment = experimentName => {
    const { mvt: { experiments = {} } = {} } = useStateContext();

    return experiments[experimentName] || null;
};

export { useExperiment };
